export default "__VITE_ASSET__BBxu90EK__"